import { Dispatch } from "@reduxjs/toolkit";
import { SidebarMenuItemType } from "../helpers/types";
import { changeSidebarPositions } from "../api/sidebar.api";

export const setSidebarPositions = (
  dispatch: Dispatch,
  newSidebarItems: SidebarMenuItemType[]
) => {
  changeSidebarPositions(dispatch, newSidebarItems);
};
